import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { de_GetSegmentCommand, se_GetSegmentCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class GetSegmentCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("Evidently", "GetSegment", {})
    .n("EvidentlyClient", "GetSegmentCommand")
    .f(void 0, void 0)
    .ser(se_GetSegmentCommand)
    .de(de_GetSegmentCommand)
    .build() {
}
